/* import __COLOCATED_TEMPLATE__ from './push-data-to-salesforce.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

interface Args {
  isSettingsPage?: boolean;
  isMessengerPage?: boolean;
}

export default class StandaloneSalesforceSetupPushDataToSalesforce extends Component<Args> {
  @service declare router: RouterService;

  get workflowUrl() {
    return this.args.isMessengerPage
      ? this.router.urlFor('apps.app.standalone.deploy.intercom-messenger.workflow')
      : this.router.urlFor('apps.app.standalone.deploy.channel', 'salesforce', 'cases');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::PushDataToSalesforce': typeof StandaloneSalesforceSetupPushDataToSalesforce;
    'standalone/salesforce/setup/push-data-to-salesforce': typeof StandaloneSalesforceSetupPushDataToSalesforce;
  }
}
